import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';

export const UserChipWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
`;

export const UserChipTrigger = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 6px 2px 2px;
  border-radius: var(--border-radius);
  background-color: transparent;
  cursor: pointer;
  @media (hover) {
    &:hover {
      background-color: var(--color-grey-f4);
    }
  }
  ${({ $isOpen }) => $isOpen && `background-color: var(--color-grey-f4);`}
`;

export const Avatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: var(--border-radius);
  background-color: var(--color-grey-f4);
  font-family: 'Geist', sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: var(--color-black);
  flex-shrink: 0;
`;

export const UserName = styled.span`
  font-family: 'Geist', sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: var(--color-black);
  white-space: nowrap;
`;

export const ChevronIcon = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  color: var(--color-black);
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.2s;
`;

/* ── Dropdown ───────────────────────────────────── */

export const DropdownContent = styled(motion.div).attrs(({ $isOpen }) => ({
  animate: { height: $isOpen ? 'auto' : 0, opacity: $isOpen ? 1 : 0 },
  transition: { duration: 0.15 },
  initial: { height: 0, opacity: 0 },
}))`
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  min-width: 160px;
  background-color: var(--color-white);
  border: 1px solid var(--color-grey-e5);
  border-radius: var(--border-radius);
  padding: 5px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  z-index: 200;
`;

export const DropdownItem = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  padding: 6px 8px;
  border-radius: 6px;
  font-family: 'Geist', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: var(--color-black);
  text-decoration: none;
  white-space: nowrap;
  @media (hover) {
    &:hover {
      background-color: #f5f5f5;
    }
  }
`;

export const DropdownSeparator = styled.div`
  height: 1px;
  background-color: var(--color-grey-e5);
  margin: 4px 0;
`;

export const DropdownLogoutButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 32px;
  padding: 6px 8px;
  border-radius: 6px;
  font-family: 'Geist', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: var(--color-grey-73);
  background-color: transparent;
  cursor: pointer;
  & svg,
  & svg * {
    color: inherit;
  }
  @media (hover) {
    &:hover {
      background-color: #fef2f2;
      color: #ff6467;
    }
  }
`;
